var Menu = {
    showMenu: function() {
        $('#menu').css({ top: window.pageYOffset }).animate({width: 'toggle'}, function() {
            $('#menu-logo').fadeIn(5000);
            $('body').removeClass('overflow-auto').addClass('overflow-hidden');
        });        
    },
    hideMenu: function() {
        $('#menu-logo').stop().fadeOut('slow');  
        $('#menu').css({ top: window.pageYOffset }).fadeOut('slow');
        $('body').removeClass('overflow-hidden').addClass('overflow-auto');        
        $('#artistMenu').slideUp('fast');
        $('#artistMenuUp').hide();
        $('#artistMenuDown').show();
    }
}

var Search = {
    show: function() {
        $('body').removeClass('overflow-auto').addClass('overflow-hidden');
        $('#search').css({ top: window.pageYOffset }).show();
    },
    hide: function() {
        $('#search').css({ top: window.pageYOffset }).hide();
        $('body').removeClass('overflow-hidden').addClass('overflow-auto');
    },
    searchPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.keyword = $('#searchText').val();
            request.type = $('#searchType').val();    
            window.axios.post('/ajax/search', request)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
            });
        });
    },
    search: function() {
        this.searchPromise()
            .then((response) => {
                //console.log(data);
                // get the url prefix
                let type = $('#searchType').val();
                let prefix = "artist";
                if (type === "2") {
                    prefix = "distro";
                }
                if (!$('.search-result').hasClass('hidden')) {
                    $('.search-result').addClass('hidden');
                }
                //$('.search-result').hide();
                $('#searchCard').html('');
                // if we have results
                if (response.data.length > 0) {
                    let content = "";
                    $.each(response.data, function(key, value) {
                        content = content + '<div class="text-2xl font-serif flex justify-center"><div class="text-2xl font-serif"><a href="/' + prefix + '/' + value.slug_name + '">' + value.name + '</a></div></div>';
                    });
                    $('#searchCard').html(content);
                } else {
                    // we have no results
                    let content = '<div class="text-2xl font-serif flex justify-center"><div class="text-2xl font-serif">No results found.</div></div>';
                    $('#searchCard').html(content);
                }
                $('.search-result').removeClass('hidden');
            })
            .catch((error) => {
                console.log(error);
        });
    }
}

var Heartbeat = {
    pulse: function() {
        setInterval(this.pulseHandle, 180000);
    },
    pulseHandle: function() {
        Heartbeat.pulsePromise()
            .then((response) => {
                // do nothing
            })
            .catch((error) => {
                // we're probably timed out, so refresh the page
                window.location.reload();
        });
    },
    pulsePromise: function() {
        return new Promise((resolve, reject) => {
            window.axios.post('/ajax/pulse', { 'status': 'alive' })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
            });
        });
    }
}

$(document).ready(function() {

    // start the pulse
    Heartbeat.pulse();

    // draw the menu on click
    $('#menuBtn').click(function() {
        if ($('#menu').is(':visible')) {
            Menu.hideMenu();
        } else {
            Menu.showMenu();
        }        
    });
    // close the menu on click
    $('#openMenuBtn').click(function() {
        Menu.hideMenu();
    });

    // hide the menu if clicked elsewhere
    $(document).on("click", function(event) {
        if ($('#menu').is(':visible')) {
            var trigger = $("#menuBtn")[0];
            var dropdown = $("#menu");
            if (dropdown !== event.target && !dropdown.has(event.target).length && trigger !== event.target) {
                Menu.hideMenu();
            }
        }
    });

    // track the mouse over the menu
    $('#menu').mouseover(function() {
        $(this).data('mouseover', true);
    }).mouseout(function() {
        $(this).data('mouseover', false);
    });

    // click a menu row
    $('.menu-row').on('click', function(e) {
        // remove the highlight of the current page if it is different from this row
        var selectedUrl = $(this).data('url');
        $.each($('.menu-row'), function(key, value) {
            if (window.location.pathname !== selectedUrl && $(this).hasClass('bg-gray-900')) {
                $(this).removeClass('bg-gray-900');
            }
        });
        window.location = $(this).data('url');
    });

    // click a artist letter
    $('.artist-letter').on('click', function(e) {
        // remove the highlight of the current page if it is different from this row
        var selectedUrl = $(this).data('url');
        $.each($('.artist-letter'), function(key, value) {
            if (window.location.pathname !== selectedUrl && $(this).hasClass('bg-gray-900')) {
                $(this).removeClass('bg-gray-900');
            }
        });
        window.location = $(this).data('url');
    });

    // set the background of the current page menu item
    $.each($('.menu-row, #artistMenuRow, .artist-letter'), function(key, value) {
        if (window.location.pathname === $(this).data('url') 
            || ($(this).data('url') !== "/" 
                && window.location.pathname.indexOf($(this).data('url-child')) > -1)
            ) {
            // highlight the row too
            $(this).addClass('bg-gray-900');
        }
    });

    // hide or show the artist menu
    $('#artistMenuRow').on('click', function(e) {
        if (!$('#artistMenu').is(':visible')) {
            $('#artistMenu').slideDown('fast');
            $('#artistMenuDown').hide();
            $('#artistMenuUp').show();
        } else {
            $('#artistMenu').slideUp('fast');            
            $('#artistMenuUp').hide();
            $('#artistMenuDown').show();
        }
    });

    // close the menu when clicking on the menu logo
    $('#menu-logo').on('click', function(e) {
        Menu.hideMenu();
    });

    // search button clicked
    $('#searchBtn').on('click', function(e) {
        Search.show();
    });
    $('#closeSearch').on('click', function(e) {
        Search.hide();
    });

    // run a search query
    $('#runSearch').on('click', function(e) {
        Search.search();
    });

    // check the search input
    $('#searchText').on('keyup', function(e) {
        if ($(this).val().length > 1) {
            $('#runSearch').removeAttr('disabled');
        } else {
            $('#runSearch').attr('disabled', 'disabled');
        }
    });

    // default button avatar click
    $('#account-avatar').click(function(e) {
        window.location = "/account";
    });

});